import { useEffect, useContext, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import Utils from "../../Utils";
import axios from "axios";

import CanvasArea from "../../components/photographer/CanvasArea";
import CommentModal from "../../components/photographer/CommentModal";
import ThumbnailList from "../../components/photographer/ThumbnailList";

const PhViewFeedback = (props) => {
  const { psid, origid, fname } = useParams();
  const fileInputRef = useRef(null);

  // active image index
  const [photoshootImages, setPhotoshootImages] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeImage, setActiveImage] = useState([]);
  const [aiFeedback, setAiFeedback] = useState([]);

  useEffect(() => {
    axios
      .get(
        Utils.apiUrl(`photoshoot/photos?psid=${psid}&origid=${origid}`),
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          var pimages = res.data.data;
          var actindex = pimages.findIndex((item) => item.fname === fname);
          console.log("actindex", actindex);
          if (actindex == -1) actindex = 0;
          console.log(pimages[actindex]);
          setAiFeedback(pimages[actindex].ai_feedback);
          setActiveIndex(actindex);
          setPhotoshootImages(res.data.data);
          setActiveImage(pimages[actindex]);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  useEffect(() => {
    if (photoshootImages.length > 0 && activeIndex < photoshootImages.length) {
      const img = photoshootImages[activeIndex];
      setActiveImage(img);
      setAiFeedback(img.ai_feedback);
    }
  }, [activeIndex, photoshootImages]);

  // store per-image data: { [imageId]: { strokes: [...], comments: [...], image: src } }
  const [imageDataMap, setImageDataMap] = useState({});

  // comment modal state handled by CanvasArea -> forwarded here for global display if needed
  const [jsonOutput, setJsonOutput] = useState("");

  // Optional: backend endpoint placeholder (set to null to disable POST)
  let BACKEND_SAVE_URL = null; // e.g. "/api/visual-analyzer/save"

  // Called by CanvasArea when strokes/comments changed (autosave to local memory)
  const handleUpdateImageData = useCallback((imageId, data) => {
    setImageDataMap((prev) => ({ ...prev, [imageId]: data }));
  }, []);

  /* For Drag and Drop Images  */
  // Drag and drop handlers for Recce Images
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      fileInputRef.current.files = files;
      // Trigger change event to upload
      fileInputRef.current.dispatchEvent(
        new Event("change", { bubbles: true }),
      );
    }
  };

  /* const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('recces', files[i]);
      }
      axios
        .post(Utils.apiUrl(`photoshoot/recces/${id}`), formData, Utils.apiHeaders())
        .then((res) => {
          if(res.data.success) {
            updateRecceImages();
            alert(res.data.message);
          }
          else {
            alert(res.data.message);
          }
          // Optionally, show success message or update UI
        })
        .catch((err) => {
          console.error('Upload failed:', err);
          // Optionally, show error message
        });
    }
  }; */

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const [rimgLoading, setRimgLoading] = useState(``);
  const submitUpdatedImage = (e) => {
    setRimgLoading(
      `<div className="text-blue-500 font-semibold py-4 loadingmess">Please wait. File upload in progress...</div>`,
    );
    const frm = e.currentTarget;
    e.preventDefault();

    const formData = new FormData();
    formData.append("psid", activeImage.photoshoot_id);
    formData.append(
      "origid",
      activeImage.orig_photo_id == null
        ? activeImage.id
        : activeImage.orig_photo_id,
    );
    formData.append("previd", activeImage.id);
    // Add attachments
    const files = frm.photo.files;
    for (let i = 0; i < files.length; i++) {
      formData.append("photo", files[i]);
    }

    axios
      .post(Utils.apiUrl(`photoshoot/photo`), formData, Utils.apiHeaders())
      .then((res) => {
        setRimgLoading(``);
        if (res.data.success) {
          alert(res.data.message);
        } else {
          alert(res.data.message);
        }
        //console.log(frmMess);
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  const submitReply = (e) => {
    const frm = e.currentTarget;
    e.preventDefault();

    const formData = new FormData();
    formData.append("photoId", activeImage.id);
    formData.append("remark", frm.remark.value);

    axios
      .put(
        Utils.apiUrl(`photoshoot/photo-remark`),
        formData,
        Utils.apiHeaders(),
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          alert(res.data.message);
        } else {
          alert(res.data.message);
        }
        //console.log(frmMess);
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  };

  return (
    <>
      <div className="page-wrap">
        <main className="flex-area container mx-auto px-2">
          <div>
            <div className="text-center text-xl mb-2">
              <a
                href={`${process.env.REACT_APP_BASENAME}photographer-photoshoot-details/${psid}`}
                className="btn text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
              >
                <i className="fas fa-arrow-left mr-2"></i> Back
              </a>
            </div>
            <aside className="thumb-column" aria-label="Image thumbnails">
              {photoshootImages.length > 0 && (
                <ThumbnailList
                  images={photoshootImages}
                  mode="photo"
                  activeId={activeImage.id}
                  origid={origid}
                  onSelect={(id) => {
                    const idx = photoshootImages.findIndex((i) => i.id === id);
                    if (idx >= 0) setActiveIndex(idx);
                  }}
                />
              )}
            </aside>
          </div>

          <section className=" flex-1">
            <div className="text-xl font-bold text-gray-800 w-full text-center flex-1 bg-gray-200 py-2 px-4 mb-2 rounded">
              Brand Feedback/Comments
            </div>
            <div className="preview">
              <CanvasArea
                key={activeImage.id} // re-mount when switching images to clean internal transient state
                image={activeImage}
                onUpdate={(data) => handleUpdateImageData(activeImage.id, data)}
              />

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 phfeedbackform">
                <div className="item">
                  <label className="text-base block mb-2">
                    Brand Team Feedback
                  </label>
                  <div className="feedback bg-gray-100 p-4 rounded-lg text-sm">
                    {activeImage.bt_feedback}
                  </div>
                </div>
                <div className="item">
                  <form onSubmit={submitReply}>
                    <label className="text-base block mb-2">Your Reply</label>
                    <div className="block messagetobt mb-2">
                      {
                        <textarea
                          name="remark"
                          id="remark"
                          placeholder="Message to Brand Team"
                          className="border-0 rounded-lg w-full py-2 px-3 bg-white-100 border-gray-300 border focus:shadow-outline"
                          defaultValue={activeImage.photographer_remarks}
                        ></textarea>
                      }
                      {false && (
                        <div className="feedback bg-gray-100 p-4 rounded-lg text-sm">
                          {activeImage.photographer_remarks}
                        </div>
                      )}
                    </div>

                    {
                      <div className="cta text-right">
                        <button
                          type="submit"
                          className="btn text-white py-1 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                          Send
                        </button>
                      </div>
                    }
                  </form>
                </div>
                {["bt-rejected"].includes(activeImage.status) && (
                  <div className="item">
                    <form onSubmit={submitUpdatedImage}>
                      <label className="text-base block mb-2">
                        Upload Revised Image
                      </label>
                      {rimgLoading && rimgLoading !== "" && (
                        <div
                          dangerouslySetInnerHTML={{ __html: rimgLoading }}
                        />
                      )}
                      <div className="feedback bg-gray-100 p-4 rounded-lg text-sm">
                        <input
                          name="photo"
                          type="file"
                          id="file-input"
                          className=""
                          ref={fileInputRef}
                        />
                      </div>
                      <div className="cta text-right mt-2">
                        <button
                          type="submit"
                          className="btn text-white py-1 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  );
};

export default PhViewFeedback;
